import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { AdminCustomerCompany } from "@/types/customer"

type AdminCustomerCompaniesState = {
  data: AdminCustomerCompany[]
  error: string | null
}

export const adminCustomerCompaniesInitialState: AdminCustomerCompaniesState = {
  data: [],
  error: null,
}

const adminCustomerCompaniesSlice = createSlice({
  name: "adminCustomerCompanies",
  initialState: adminCustomerCompaniesInitialState,
  reducers: {
    setAdminCustomerCompaniesAction: (
      state,
      action: PayloadAction<AdminCustomerCompany[]>,
    ) => {
      state.data = action.payload
      state.error = null
    },
    setAdminCustomerCompaniesErrorAction: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.error = action.payload
    },
  },
})

export const {
  setAdminCustomerCompaniesAction,
  setAdminCustomerCompaniesErrorAction,
} = adminCustomerCompaniesSlice.actions

export default adminCustomerCompaniesSlice.reducer
